import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom'; // Added BrowserRouter
import ModalPopup from './components/ModalPopup';
import Contactpop from './components/sections/Contactpop';
import Route from './mainRouter';
import ScrollToTop from './components/ScrollToTop';

function App() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 20000); // 10 seconds

    return () => clearTimeout(timer);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <Router> {/* Added Router */} 
      <div className="App">
        <ScrollToTop />
        <Route />
        
        {showPopup && (
          <ModalPopup onClose={closePopup}>
            <Contactpop />
          </ModalPopup>
        )}
      </div>
    </Router> 
  );
}

export default App;